var styles = {"box":"Icon_box_14tdo_1","icon":"Icon_icon_14tdo_8","show":"Icon_show_14tdo_26","active":"Icon_active_14tdo_29"};

export { styles as default };
//# sourceMappingURL=index.module.scss.js.map
